import React from "react";
import { Sun, Moon } from "lucide-react";

export default function ThemeToggle({ theme, onToggle }) {
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      data-testid="theme-toggle"
      onClick={onToggle}
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      className="inline-flex items-center gap-2 px-3 py-2 mr-2 md:mr-3 text-[0.68rem] uppercase tracking-[0.2em] transition-colors"
      style={{
        border: `1px solid ${isDark ? "rgba(217,193,136,0.7)" : "#bfa15f"}`,
        color: isDark ? "#f5ecd8" : "#0f172a",
        backgroundColor: isDark
          ? "rgba(217,193,136,0.08)"
          : "rgba(191,161,95,0.08)",
      }}
    >
      {isDark ? (
        <Sun className="w-3.5 h-3.5" strokeWidth={1.6} />
      ) : (
        <Moon className="w-3.5 h-3.5" strokeWidth={1.6} />
      )}
      <span className="hidden sm:inline">
        {isDark ? "Light" : "Dark"}
      </span>
    </button>
  );
}
